// Миксины нужны для того, чтобы не имппортировать переменные и функции из store в каждый компонент
// Импортируем их сюда и обращаемся как обычно везде

export default {
    computed: {
        loading() { return this.$store.state.loading },

        selectedOrder() { return this.$store.state.selectedOrder },
        modalAddOrderOpen() { return this.$store.state.modalAddOrderOpen },

        globalAlerts() { return this.$store.state.globalAlerts },

        isAdmin() { return this.$store.getters.isAdmin },
        isOperator() { return this.$store.getters.isOperator },
        isCleaner() { return this.$store.getters.isCleaner },

        user() { return this.$store.state.user },
    },
    methods: {
        setModalAddOrderOpen(value) { this.$store.commit('setModalAddOrderOpen', value); },
        setSelectedOrder(value) { this.$store.commit('setSelectedOrder', value); },

        setLoading(value) { this.$store.commit('setLoading', value); },

        setSettings(value) { this.$store.commit('setSettings', value); },

        setUser(value) { this.$store.commit('setUser', value); },

        requestData(value) { return this.$store.dispatch('requestData', value) },

        createAlert(value) { return this.$store.dispatch('createAlert', value) },
        removeAlertById(value) { this.$store.commit('removeAlertById', value); },
        removeAlertsByType(value) { this.$store.commit('removeAlertsByType', value); },
    
        getFormatDate(date) {
            if (!date) return "";
            const dateMatch = new Date(date);
            dateMatch.setDate(dateMatch.getDate());
            const dateMatchFormat = ('0' + dateMatch.getDate()).slice(-2) + '.' + ('0' + (dateMatch.getMonth() + 1)).slice(-2) + '.' + dateMatch.getFullYear();
            return dateMatchFormat;
        },

        isToday(dateStr) {
            const inputDate = new Date(dateStr);
            const today = new Date();
        
            return (
                inputDate.getFullYear() === today.getFullYear() &&
                inputDate.getMonth() === today.getMonth() &&
                inputDate.getDate() === today.getDate()
            );
        }
    
    }
};